export default __webpack_public_path__ + "static/media/pandas.9bd98d45.svg";